module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eZrxn"))).then(() => parcelRequire('d0iPb'));